var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3428_11935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.25 25C34.7084 25 37.4792 22.2083 37.4792 18.75C37.4792 15.2917 34.7084 12.5 31.25 12.5C30.5834 12.5 29.9375 12.6042 29.3542 12.7917C30.5417 14.4792 31.2292 16.5208 31.2292 18.75C31.2292 20.9792 30.5209 23 29.3542 24.7083C29.9375 24.8958 30.5834 25 31.25 25ZM20.8334 25C24.2917 25 27.0625 22.2083 27.0625 18.75C27.0625 15.2917 24.2917 12.5 20.8334 12.5C17.375 12.5 14.5834 15.2917 14.5834 18.75C14.5834 22.2083 17.375 25 20.8334 25ZM20.8334 29.1667C16.6667 29.1667 8.33337 31.25 8.33337 35.4167V37.5C8.33337 38.6458 9.27087 39.5833 10.4167 39.5833H31.25C32.3959 39.5833 33.3334 38.6458 33.3334 37.5V35.4167C33.3334 31.25 25 29.1667 20.8334 29.1667ZM34.625 29.5C36.3542 31.0208 37.5 32.9583 37.5 35.4167V38.5417C37.5 38.8958 37.4584 39.25 37.3959 39.5833H42.7084C43.2917 39.5833 43.75 39.125 43.75 38.5417V35.4167C43.75 32.2083 38.8125 30.2292 34.625 29.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3428_11935",
    x: 4.33337,
    y: 10.5,
    width: 43.4166,
    height: 35.0834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3428_11935"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3428_11935",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconImage);
export default __webpack_public_path__ + "static/media/userIconImage.16a2ff93ba6509e28d45a85cf80b8ed4.svg";
export { ForwardRef as ReactComponent };